import { Pipe, PipeTransform, NgModule, SecurityContext } from '@angular/core';
import { DomSanitizer } from '@angular/platform-browser';

@Pipe({ name: 'nl2br', standalone: false })
export class Nl2BrPipe implements PipeTransform {
  constructor(private sanitizer: DomSanitizer) {}

  /**
   * Replaces newline characters with <br /> tags
   * @param value - The string to transform
   * @param sanitizeBeforehand - Whether to sanitize the HTML
   * @returns String with newlines replaced by <br /> tags
   */
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  transform(value: string, sanitizeBeforehand?: boolean): any {
    if (typeof value !== 'string') {
      return value;
    }
    const textParsed = value.replace(/(?:\r\n|\r|\n)/g, '<br />');
    if (sanitizeBeforehand) {
      return this.sanitizer.sanitize(SecurityContext.HTML, textParsed);
    }
    return textParsed;
  }
}

@NgModule({
  declarations: [Nl2BrPipe],
  exports: [Nl2BrPipe],
})
export class Nl2BrPipeModule {}
